/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Enum_Law_Tax_Public_Admin17Inputs */

const en_job_form_enum_law_tax_public_admin17 = /** @type {(inputs: Job_Form_Enum_Law_Tax_Public_Admin17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Law, Tax and Public Administration`)
};

const de_job_form_enum_law_tax_public_admin17 = /** @type {(inputs: Job_Form_Enum_Law_Tax_Public_Admin17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recht, Steuern und öffentliche Verwaltung`)
};

/**
* | output |
* | --- |
* | "Law, Tax and Public Administration" |
*
* @param {Job_Form_Enum_Law_Tax_Public_Admin17Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_enum_law_tax_public_admin17 = /** @type {((inputs?: Job_Form_Enum_Law_Tax_Public_Admin17Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Enum_Law_Tax_Public_Admin17Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_enum_law_tax_public_admin17(inputs)
	return en_job_form_enum_law_tax_public_admin17(inputs)
});
export { job_form_enum_law_tax_public_admin17 as "job_form_enum_LAW_TAX_PUBLIC_ADMIN" }